export default {title:'Conditions for Enhanced Funding'};